<template>
  <TopGradientBlockLayout style="height: auto;">
    <div class="text-xl font-bold text-text leading-tight mb-8">
      {{ budgetTitle(selectedBudget) }}
    </div>
    <TransactionEditModalProvider :transaction="edit_transaction"
                                  :position="'absolute'"
                                  @finished="updateTransactions"
                                  @close="edit_transaction = null"/>
    <div v-if="loading"></div>
    <div v-else-if="!transactions.length" class="text-center text-lg text-text">{{ $t('noTransactions') }}</div>
    <div v-else>
      <div v-for="(transactionDate,date,i) in budgetTransactions" :key="i">
        <TransactionDate :date="date" :transactions="transactionDate" class="md:-mx-6"/>
        <TransactionItem v-for="(transaction,j) in transactionDate" :key="j"
                         :transaction="transaction"
                         :layout="'budget'"
                         @edit="edit_transaction = $event"/>
      </div>
      <div class="mt-10" v-show="current_page < pages_length || more_loading">
                <span v-if="!more_loading"
                      class="text-2sm text-text-ternary cursor-pointer
                      transition duration-200
                      border-b border-dashed border-text-ternary
                      hover:text-red hover:border-red"
                      @click="showMore">{{ $t('showMore') }}</span>
        <font-awesome-icon class="text-primary" v-else icon="circle-notch" spin/>
      </div>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import TransactionList from "@/components/cabinet/Money/Transactions/TransactionList";
import TransactionEditModalProvider
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModalProvider";
import TransactionDate from "@/components/common/Transaction/TransactionDate";
import TransactionItem from "@/components/common/Transaction/TransactionItem/TransactionItem";

export default {
  name: "BudgetTransactions",
  props: {
    budget: {
      type: Object
    },
  },
  data() {
    return {
      more_loading: false,
      edit_transaction: null
    }
  },
  components: {
    TransactionItem,
    TransactionDate,
    TransactionEditModalProvider,
    TransactionList, TopGradientBlockLayout
  },
  computed: {
    ...mapState('space/budgets', {
      selectedBudget: state => state.budgetSelected,
      transactions: state => state.budgetSelectedTransactions.data,
      loading: state => state.budgetSelectedTransactions.dirty,
      current_page: state => state.budgetSelectedTransactions.pagination.current_page,
      pages_length: state => state.budgetSelectedTransactions.pagination.pages
    }),
    ...mapGetters('space/budgets', ['budgetTitle', 'budgetTransactions']),
  },
  methods: {
    ...mapActions('space/budgets', ['loadMoreBudgetTransactions', 'loadBudgetsTransactions', 'getBudgets']),
    ...mapMutations('space/budgets', ['setBudgetTransactionsPage']),
    showMore() {
      this.setBudgetTransactionsPage(this.current_page + 1)
    },
    updateTransactions() {
      this.loadBudgetsTransactions(this.budget)
      this.getBudgets()
    }
  },
  watch: {
    current_page() {
      this.more_loading = true
      this.loadMoreBudgetTransactions()
      this.more_loading = false
    }
  },
  i18n: {
    messages: {
      en: {
        noTransactions: 'No transactions',
        showMore: 'Show more'
      },
      ru: {
        noTransactions: 'Ничего не найдено',
        showMore: 'Показать больше'
      }
    }
  }
}
</script>